import React from "react";
import connect from "Shared/connect";
import classnames from "classnames";
import MobileField from "./MobileField";
import Button from "./Button";
import * as searchHistory from "../../../../../Search/search-history";
import { searchPageUrl } from "Shared/known-urls";
import { loadQuickSearch, closeQuickSearch, showQuickSearch, updateSelectedCompletion, } from "../../../../../Search/action-creators";
import * as styles from "./mobile.scss";
import { scrollPosition } from "SiteLayout/Root";
import Flyout from "Shared/Flyout";
import { urlToString } from "Shared/url";
import { pushState } from "Shared/history";
class MobileQuickSearch extends React.Component {
    constructor() {
        super(...arguments);
        this.go = () => {
            this.props.closeQuickSearch();
            scrollPosition(0);
            const searchText = this.props.quickSearch.searchText;
            if (searchText.length) {
                searchHistory.add(searchText);
                pushState(urlToString({
                    path: searchPageUrl().url,
                    query: { q: this.props.quickSearch.searchText },
                }));
            }
        };
    }
    open() {
        this.props.showQuickSearch();
    }
    onButtonClick() {
        if (!this.props.quickSearch.isOpen) {
            this.open();
        }
        else {
            this.go();
        }
    }
    render() {
        const isOpen = this.props.quickSearch.isOpen;
        return (React.createElement("div", { className: classnames({ [styles.open]: isOpen }) },
            React.createElement(Button, { className: styles.base, onClick: () => this.onButtonClick() }),
            React.createElement(Flyout, { position: "right", canOpen: true, toggleFlyout: null, isOpen: isOpen, fillWidth: true },
                React.createElement(MobileField, { completionsLists: this.props.quickSearch.completionsLists, searchText: this.props.quickSearch.searchText, onChange: this.props.loadQuickSearch, onClose: this.props.closeQuickSearch, onSearch: this.go }))));
    }
}
export default connect((state) => ({
    quickSearch: state.quickSearch,
}), (dispatch) => ({
    loadQuickSearch: (searchText) => dispatch(loadQuickSearch(searchText)),
    updateSelectedCompletion(index, type) {
        dispatch(updateSelectedCompletion(index, type));
    },
    closeQuickSearch() {
        dispatch(closeQuickSearch());
    },
    showQuickSearch() {
        dispatch(showQuickSearch());
    },
}))(MobileQuickSearch);
